<div class="folder">
  <div>
    <span class="folder__main">
      <mat-icon class="material-symbols-outlined">folder</mat-icon>
      {{ folder?.folderName || 'Root folder' }}
    </span>
  </div>
  @if (folder?.files) {
    @if (folder?.folders?.length || folder?.files?.length) {
      <div class="table-wrapper">
        <table mat-table [dataSource]="folder | tableData" class="table">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element">
              <div class="table__cell">
                @if (!element.category) {
                  <i class="material-icons-outlined table__cell--folder-icon">folder</i>
                  <a [routerLink]="['.']" [queryParams]="{ folder: element.id }" [queryParamsHandling]="'merge'">
                    {{ element.name }}
                  </a>
                } @else {
                  <img class="table__cell--file-icon" [src]="element.name | fileIcon" />{{ element.name }}
                }
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="uploadedAt">
            <th mat-header-cell *matHeaderCellDef>Date uploaded</th>
            <td mat-cell *matCellDef="let element">
              {{ element.uploadedAt || element.createdAt | date: 'yyyy-MM-dd hh:mm' : userTimezone }}
            </td>
          </ng-container>

          <ng-container matColumnDef="uploadedBy">
            <th mat-header-cell *matHeaderCellDef>Uploaded by</th>
            <td mat-cell *matCellDef="let element">{{ element.uploadedBy || element.createdBy }}</td>
          </ng-container>

          <ng-container matColumnDef="company">
            <th mat-header-cell *matHeaderCellDef>Company name</th>
            <td mat-cell *matCellDef="let element">{{ element.companyName }}</td>
          </ng-container>

          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef>Category</th>
            <td mat-cell *matCellDef="let element">{{ element.category }}</td>
          </ng-container>

          <ng-container matColumnDef="size">
            <th mat-header-cell *matHeaderCellDef>Size</th>
            <td mat-cell *matCellDef="let element">{{ element.size | fileSize }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let element">
              <div class="table__cell">
                <div class="table__cell--actions">
                  @if (element.category) {
                    <i class="material-icons-outlined download-file" (click)="download(element)">file_download</i>
                    <i class="material-icons-outlined delete-file" (click)="deleteFileBy(element.id)">delete</i>
                  } @else {
                    <i class="material-icons-outlined rename-folder" (click)="folderEditBy(element.id)">edit</i>
                    <i class="material-icons-outlined delete-folder" (click)="deleteFolderBy(element.id)">delete</i>
                  }
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table__header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    } @else {
      <div class="folder__empty-list">
        <i class="material-icons-outlined">info</i>
        No files have been uploaded and no folders created yet
      </div>
    }
  }
  <mat-paginator
    [hidePageSize]="true"
    [length]="folder?.totalCount"
    [pageSize]="20"
    [pageIndex]="pageNumber - 1"
    (page)="onPageChange($event)"></mat-paginator>
</div>
